import { createContext, useContext, useEffect, useState } from "react";
import { api } from "@/lib/api";

const SiteCtx = createContext(null);

export const asset = (u) => (u && u.startsWith("/api") ? `${process.env.REACT_APP_BACKEND_URL}${u}` : u);

const rgb = (hex, f = 1) => [1, 3, 5].map((i) => Math.round(parseInt(hex.slice(i, i + 2), 16) * f)).join(" ");

const applyColors = (s) => {
  const root = document.documentElement.style;
  root.setProperty("--brand", rgb(s.primary_color));
  root.setProperty("--brand-dark", rgb(s.primary_color, 0.82));
  root.setProperty("--sun", rgb(s.accent_color));
  root.setProperty("--sun-dark", rgb(s.accent_color, 0.88));
};

export const SiteProvider = ({ children }) => {
  const [site, setSiteState] = useState(null);
  const setSite = (s) => { applyColors(s); setSiteState(s); };
  useEffect(() => {
    api.get("/settings").then((r) => setSite(r.data)).catch(() => setSiteState({}));
  }, []);
  if (!site) return <div className="min-h-screen" data-testid="site-loading" />;
  return <SiteCtx.Provider value={{ ...site, setSite }}>{children}</SiteCtx.Provider>;
};

export const useSite = () => useContext(SiteCtx);
